import { jsx as _jsx } from "react/jsx-runtime";
import { StylesAsDataAttributes } from 'substyle-glamor';
import Stick from '../../../es';
import Regression from './Regression';
export default function StyledWithDataAttributes() {
    return (_jsx(Regression, { allBrowsers: true, fixed: true, version: "2.1.0", title: "Should not expect a style attribute", description: "The Stick component should not expect a `style` property to be present on its props.", children: _jsx(StylesAsDataAttributes, { children: _jsx("div", { style: { display: 'flex', justifyContent: 'center' }, children: _jsx(Stick, { position: "bottom center", node: _jsx("div", { style: {
                            backgroundColor: '#ae0d5c',
                            color: 'white',
                            width: 100,
                        }, children: "Node" }), children: _jsx("div", { style: { backgroundColor: 'rgb(24, 170, 177)', width: 200 }, children: "Anchor" }) }) }) }) }));
}
